import { FileType } from '@office-start/document-types';
import { OfficeRouteItemType } from '@office-start/officehome-types';
import { Referral, } from '@office-start/telemetry-types';
import { AdminAcquiredAppsCustomValidator } from '../shared';
var adminAcquiredAppsExistUserPages = [
    'Content',
    'OfficeHome',
    'Pwa',
    'Search',
    'SearchSiteScoped',
    'SearchPersonScoped',
    'Start',
    'Templates',
    'AppItems',
    'Create',
    'GroupItems',
    'M365Apps',
    'MyForms',
    'GroupForms',
    'EnterpriseTemplates',
    'MyContent',
    'Feed',
];
export var CommercialNewUserMyContentTuiItem = {
    id: 'NewUserCommercialMyContentTuiItem',
    type: 'item',
    callout: 'Manage_Content_Commercial_Callout',
    activationSettings: {
        featureGates: function (gates) { var _a, _b; return (_b = (_a = gates === null || gates === void 0 ? void 0 : gates.myContentGates) === null || _a === void 0 ? void 0 : _a.myContentEnabled) !== null && _b !== void 0 ? _b : false; },
    },
};
export var NewUserInstallTuiItem = {
    id: 'NewUserInstallTuiItem',
    type: 'item',
    callout: 'Download_Apps_Callout',
};
export var CommercialNewUserCreateTuiItem = {
    id: 'CommercialCreateTuiItem',
    type: 'item',
    callout: 'Create_Here_Commercial_Callout',
};
export var FeedModuleTuiItem = {
    id: 'FeedModule_Sequence',
    type: 'item',
    activationSettings: {
        pages: ['OfficeHome', 'Pwa'],
        impressionEvents: [
            "Callout_Feed_Sequence" /* KnownImpressionInstrumentationEvents.CalloutFeedSequenceImpression */,
        ],
        featureGates: function (gates) { var _a, _b; return (_b = (_a = gates.feedGates) === null || _a === void 0 ? void 0 : _a.feedEnabled) !== null && _b !== void 0 ? _b : false; },
    },
    impressionEvent: "Callout_Feed_Sequence" /* KnownImpressionInstrumentationEvents.CalloutFeedSequenceImpression */,
    callout: 'Feed_Callout',
};
export var VisioLibraryTileTuiItem = {
    id: 'Visio_Library_Tile_Callout',
    type: 'standalone',
    activationSettings: {
        pages: ['Start'],
        impressionEvents: [
            "Visio_Library_Tile_Impression" /* KnownImpressionInstrumentationEvents.VisioLibraryTileImpression */,
        ],
        featureGates: function (gates) {
            var _a, _b, _c;
            return (_c = (((_a = gates.modernTemplatesGates) === null || _a === void 0 ? void 0 : _a.modernTemplatesEnabled) &&
                ((_b = gates.visioTemplatesGates) === null || _b === void 0 ? void 0 : _b.visioTemplatesLibraryTileCalloutEnabled))) !== null && _c !== void 0 ? _c : false;
        },
        appMode: FileType.Visio,
    },
    impressionEvent: "Visio_Library_Tile_Impression" /* KnownImpressionInstrumentationEvents.VisioLibraryTileImpression */,
    callout: 'Visio_Library_Tile_Callout',
    actionButton: {
        text: 'visioLibraryTileCalloutButtonText',
        action: function (_a) {
            var navigateUrl = _a.navigateUrl;
            navigateUrl === null || navigateUrl === void 0 ? void 0 : navigateUrl({
                route: 'Templates',
                app: FileType.Visio,
            }, undefined);
        },
    },
};
export var AdminAcquiredAppsTuiItem = {
    id: 'AdminAcquiredAppsTuiItem',
    type: 'standalone',
    activationSettings: {
        pages: adminAcquiredAppsExistUserPages,
        impressionEvents: [
            "Callout_Admin_Acquired_Apps" /* KnownImpressionInstrumentationEvents.CalloutAdminAcquiredAppsImpression */,
        ],
        isRecurring: true,
        featureGates: function (gates) {
            var _a, _b, _c;
            return (_c = (((_a = gates.appsModuleGates) === null || _a === void 0 ? void 0 : _a.appsModuleEnabled) &&
                ((_b = gates.adminAcquiredAppsGates) === null || _b === void 0 ? void 0 : _b.adminAcquiredAppsEnabled))) !== null && _c !== void 0 ? _c : false;
        },
        customValidator: AdminAcquiredAppsCustomValidator,
    },
    impressionEvent: "Callout_Admin_Acquired_Apps" /* KnownImpressionInstrumentationEvents.CalloutAdminAcquiredAppsImpression */,
    callout: 'Admin_Acquired_Apps_Callout',
    actionButton: {
        text: 'calloutActionButtonViewAppsText',
        action: function (_a) {
            var navigateUrl = _a.navigateUrl;
            var param = {
                area: 'TuiCallout',
                eventName: 'ViewAppsClick',
                elementId: 'view-apps-button',
                referral: Referral.AppGallery,
                clickParams: {},
            };
            navigateUrl === null || navigateUrl === void 0 ? void 0 : navigateUrl({
                route: 'AppGallery',
                type: OfficeRouteItemType.Base,
            }, undefined, param);
        },
    },
    onDismiss: function (_a) {
        var setDismissedTimestamp = _a.setDismissedTimestamp;
        setDismissedTimestamp(Date.now());
    },
};
export var AddContentTuiItem = {
    id: 'AddContent',
    type: 'item',
    activationSettings: {
        pages: ['MyContent'],
        impressionEvents: [
            "Callout_Add_Content" /* KnownImpressionInstrumentationEvents.CalloutAddContentImpression */,
        ],
        featureGates: function (gates) { var _a, _b; return (_b = (_a = gates.edgeworthConfigGates) === null || _a === void 0 ? void 0 : _a.edgeworthConfigLinksEnabled) !== null && _b !== void 0 ? _b : false; },
    },
    impressionEvent: "Callout_Add_Content" /* KnownImpressionInstrumentationEvents.CalloutAddContentImpression */,
    callout: 'Add_Content_Callout',
};
//# sourceMappingURL=tui-items.js.map